<div mat-dialog-title class="dialog-title">
    <h1 >Consulta individual</h1>
    <button mat-icon-button  mat-dialog-close style="border:none">
      X
    </button>
  </div>
<div mat-dialog-content>
    <div class="row" style="margin-top: 30px;margin-bottom: 20px;">
        <div class="col-md-1"></div>
        <div clas="col-md-10">
            <h3>Seleccione el tipo de consulta que desea realizar</h3>
            <select class="form-control" [(ngModel)]="codigoConsulta" (change)="changeMessage()">
                <option value="3">Información general de cliente</option>
                <option value="1">Numero de precalificación</option>
                <option value="2">Precalificaciones por cliente</option>
              </select>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-1"></div>
        <div class="col-md-10" style="padding-left: 0;padding-right: 10px;">
            <br>
            <div class="form-group">
                <label for="exampleInputEmail1">{{mensajeConsulta}}</label>
                <input [(ngModel)]="parametroConsulta" type="number" class="form-control" name="monto" min="0">
            </div>
            <h3 Style="color:#dd2460;text-align: center;" *ngIf="alertError">{{alertaValidacion}}</h3>
        </div>
        <div class="row" style="width:100%" *ngIf="codigoConsulta==2">
            <div class="col-md-1"></div>
            <div class="col-md-5" style="padding-right: 0;">
                <input class="form-control form-rounded"
                    style="width: 100%;"
                   type="date"
                   [min]="beginLimitDate"
                   [max]="maxDate"
                   [(ngModel)]="beginDate">
              </div>
              <div class="col-md-5" style="padding-right: 0;" >
                <input class="form-control form-rounded" type="date"
                   [(ngModel)]="endDate"
                   [min]="beginLimitDate"
                   [max]="maxDate">
              </div>
              <div class="col-md-1"></div>
        </div>
        <div class="col-md-1"></div>

        <div class="col-md-12">
            <div style="text-align: center;">
                <button class="btn round-button" (click)="realizarConsulta()">Consultar</button>
            </div>
        </div>
    </div>
</div>
